import { goBackModal } from 'presentation/main/globalModals/globalModals.utils'
import { modals } from 'presentation/main/modals/modals'
import { FailedInvoiceModalProps } from './FailedInvoiceModal.types'

type Params = Omit<FailedInvoiceModalProps, 'isOpen' | 'onClose'>

export const openFailedInvoiceModal = ({
  onSuccess,
  onError,
  failedInvoiceSummary,
}: Params): void => {
  modals.emitter.emit({
    type: 'OPEN',
    payload: {
      key: 'FAILED_INVOICE_MODAL',
      props: {
        onSuccess,
        onError,
        failedInvoiceSummary,
        onClose: goBackModal,
      },
    },
  })
}
